import React from "react";
import { Link } from "react-router-dom";

export default class CategoryList extends React.Component {
    render() {
        var data = this.props.data;

        var fullWidthClass = "";
        if (data.fullWidth === true && this.props.mediaType !== "desktop") {
            fullWidthClass = " full-width";
        }

        return <Link className={"category-item" + fullWidthClass} to={data.href.url} style={{backgroundImage: `url(${data.backgroundImage.mediaItemUrl})`}}>
            <div className="dark-opacity"></div>
            <span className="title">{data.title}</span>
            <span className="cta">{data.ctaText}</span>
        </Link>;
    }
}